import CryptoJS from 'crypto-js';
const { REACT_APP_BASE_URL, REACT_APP_API_URL, REACT_APP_GOOGLE_MAPS_KEY, REACT_APP_API_KEY, REACT_APP_POWERSYNC_URI, REACT_APP_PIN_ENCRYPTION_KEY } = process.env;
console.log("PIN KEY:", process.env.REACT_APP_PIN_ENCRYPTION_KEY);
console.log("API URL:", process.env.REACT_APP_API_URL);

export const baseUrl      = REACT_APP_BASE_URL;
export const apiUrl       = REACT_APP_API_URL;
export const apiKey       = REACT_APP_API_KEY;

export const googleMapsApiKey = REACT_APP_GOOGLE_MAPS_KEY;

export const powerSyncDBUrl   = REACT_APP_POWERSYNC_URI;

export const cryptoService = {
  key: REACT_APP_PIN_ENCRYPTION_KEY,

  encryptData(plainText) {
    // Truncate or pad key to 16 bytes (same as Dart logic)
    const key = CryptoJS.enc.Utf8.parse(this.key.padEnd(16, ' ').substring(0, 16));

    // Use a 16-byte IV filled with zeros
    const iv = CryptoJS.enc.Utf8.parse('\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0');

    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString(); // Base64 string
  }
};

